export const designTokens = {
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48,
  },

  borderRadius: {
    small: 4,
    medium: 8,
    large: 12,
    pill: 999,
  },

  fontWeights: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },

  fontSize: {
    xs: 12,
    sm: 14,
    base: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 29,
    '4xl': 35,
  },

  zIndex: {
    dropdown: 1000,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },

  harvestColors: {
    darkBlue: '#161D28',
    taupeGray: '#E3E2E0',
    lightGray: '#EEEEEC',
    steelBlue: '#90A9B2',
    lightBlue: '#BCCBD1',
    red: '#CA806C',
    lightRed: '#DBAB9F',
    green: '#667B61',
    lightGreen: '#A3B0A0',
    yellow: '#E1B079',
    lightYellow: '#EDD0AF',
  },

  customColors: {
    primary: {
      light: {
        main: '#89AAB3',
        light: '#B8CBD2',
        dark: '#6d8c94',
        contrastText: '#ffffff',
      },
      dark: {
        main: '#7aa7ff',
        light: '#a5c3ff',
        dark: '#3d6fd8',
        contrastText: '#0a0b0e',
      },
    },
    secondary: {
      main: '#757575', // Changed from #e0e0e0 for better contrast (4.61:1 - WCAG AA compliant)
      light: '#9e9e9e',
      dark: '#616161',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#0d151c',
      secondary: '#6b7280',
      disabled: '#9ca3af',
    },
    background: {
      paper: '#ffffff',
      default: '#fafafa',
      dark: '#f6f8fb',
      grey: '#cccccc',
    },
    action: {
      hover: 'rgba(0, 0, 0, 0.04)', // Changed from blue tint to neutral gray for proper hover state
      selected: '#e5e5e5',
      disabled: '#f3f4f6',
    },
    // Gradient backgrounds for cards and containers
    gradients: {
      light: {
        card: 'linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 252, 248, 0.98) 100%)',
        cardHover: 'linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 250, 245, 1) 100%)',
        container: 'linear-gradient(135deg, rgba(155, 95, 23, 0.06) 0%, rgba(102, 123, 97, 0.08) 100%)',
        dashboard: 'linear-gradient(135deg, rgba(155, 95, 23, 0.08) 0%, rgba(181, 115, 45, 0.06) 100%)',
      },
      dark: {
        card: 'linear-gradient(135deg, rgba(18, 20, 24, 0.98) 0%, rgba(26, 28, 32, 0.98) 100%)',
        cardHover: 'linear-gradient(135deg, rgba(26, 28, 32, 1) 0%, rgba(32, 34, 40, 1) 100%)',
        container: 'linear-gradient(135deg, rgba(122, 167, 255, 0.08) 0%, rgba(102, 123, 97, 0.1) 100%)',
        dashboard: 'linear-gradient(135deg, rgba(122, 167, 255, 0.12) 0%, rgba(165, 195, 255, 0.08) 100%)',
      },
    },
    // Border colors for themed borders
    borders: {
      light: {
        subtle: 'rgba(155, 95, 23, 0.08)',
        medium: 'rgba(155, 95, 23, 0.12)',
        strong: 'rgba(155, 95, 23, 0.15)',
        hover: 'rgba(155, 95, 23, 0.2)',
      },
      dark: {
        subtle: 'rgba(122, 167, 255, 0.15)',
        medium: 'rgba(122, 167, 255, 0.2)',
        strong: 'rgba(122, 167, 255, 0.25)',
        hover: 'rgba(122, 167, 255, 0.3)',
      },
    },
  },
};
